import React, { useEffect, useState } from 'react';

const getSize = () => [window.innerWidth, window.innerHeight];

const useWindowSize = () => {
  const [size, setSize] = useState(getSize());

  useEffect(() => {
    const updateSize = () => setSize(getSize());
    window.addEventListener('resize', updateSize);

    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  return size;
};

export default useWindowSize;
